import React, { Component } from 'react';
import Search from '../../components/Search';
import DataTable from '../../components/DataTable';
import { connect } from 'react-redux'
import {Card, CardBody, CardTitle, CardHeader} from "reactstrap";
import { setSearchData } from '../../actions/search';
import lodash  from 'lodash/array';
import { getAllFiles }  from '../../actions/file';
import { getAllProducts } from '../../actions/product';
import {fileTypeFetchData, fileMetaDataValueWithCategoryFetchData} from '../../actions/fileData'
import {clientFetchData} from '../../actions/clientData'
import Loader from '../../components/Loader';
import moment from 'moment';
import { setSearchScope } from '../../helpers';
class Overview extends Component {

	constructor(props,context) {
        super(props,context);



        this.additionalColumns = [
        {
                Header: 'Is verstuurd naar klant?',
                accessor: 'is_been_notified',
                Cell: props => <span>{props.value == '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
				
        },
		{
			Header: 'Is verwijderd?',
			accessor: 'is_deleted',
			Cell: props => <span>{props.value == '1' ? <i className="fa fa-check"></i> : <i className="fa fa-times"></i>}</span>
		},
        {
            Header: 'Aanpassen',
            accessor: 'id',
            Cell: props => <span><a href={'/#/files/update/'+props.value} style={{display : 'inline'}} className="nav-link"><i className="fa fa-pencil"></i> Bewerken</a></span>
        }
        ]

		this.columns = [{
			Header: 'Klant',
			accessor: 'addresses',
			Cell: props => <span>{this.getClient(props.value)}</span>
		},{
				Header: 'Adres',
				accessor: 'addresses',
				Cell: props => <span>{this.getAddress(props.value)}</span>
		},{
				Header: 'Bestandstype',
				accessor: 'file_type_name',
		},{
				Header: 'Valt onder product',
				accessor: 'product_name',
		},{
				Header: 'Upload datum',
				accessor: 'upload_date',
				sortMethod: (a, b) => {
					a = parseInt(moment(a, 'DD-MM-YYYY HH:mm:ss').toDate().getTime());
					b = parseInt(moment(b, 'DD-MM-YYYY HH:mm:ss').toDate().getTime())
					if (a === b) {
					  return a > b ? 1 : -1;
					}
					return a > b ? 1 : -1;
				  }


		},{
			Header: 'Geupload door',
			accessor: 'uploaded_by_name',
			}
		]

		this.state = {
			fileData : []
		}

    }

    getClient (addresses) {
        if(addresses) {

			if ( this.props.clientData ) {
				if ( this.props.clientData.allAddresses ) {
					if ( this.props.clientData.allAddresses.length ) {
						const address = this.props.clientData.allAddresses.find(e => e.dp_address_id === addresses[0].value)
						if ( address !== undefined ) {
						  return address.client_name;
					  }
					}
				}
			}



        }
    }

     getAddress (addresses) {
        if(addresses) {


			if ( this.props.clientData ) {
				if ( this.props.clientData.allAddresses ) {
					if ( this.props.clientData.allAddresses.length ) {
           				const address = this.props.clientData.allAddresses.find(e => e.dp_address_id === addresses[0].value)
						if ( address !== undefined ) {
							  return address.street +' '+address.city;
						  }
				   }
			   }
			}


        }
    }

	_formatDataWithAddress(files = []) {
		let newFilesData = [];

		files.forEach((item, i) => {
			let addressArray = [];
			let clientArray = []
			if ( item.addresses ) {
				item.addresses.forEach((address, i) => {
					addressArray.push(this.getAddress([ { value : address.value}]));
					clientArray.push(this.getClient([ { value : address.value}]));
				});
			}
			let newItem = {
				...item,
				addresses_string : addressArray.join(', '),
				client_string : clientArray.join(', ')
			}
			newFilesData.push(newItem);
		});
		return newFilesData
	}

	componentWillMount() {
		setSearchScope('messages');
        if(this.props.clientPath.clientPath) {
            this.props.getAllFiles(this.props.clientPath.clientPath)
            this.props.getAllProducts(this.props.clientPath.clientPath)
            this.props.fileTypeFetchData(this.props.clientPath.clientPath)
            this.props.fileMetaDataValueWithCategoryFetchData(this.props.clientPath.clientPath)
            this.props.clientFetchData(this.props.clientPath.clientPath)
        }
	}
	
	componentDidMount() {
        window.scrollTo(0, 0)
    }

	componentDidUpdate(prevProps) {

        if(prevProps.fileData != this.props.fileData) {
			const fileData = this._formatDataWithAddress(this.props.fileData.files);
			this.setState({
				fileData : fileData
			})
            this.props.updateSearchData(fileData)
        }
    }
	render() {
          const filterValues = {
            showSend : {
                name: 'Is verstuurd',
                type: 'checkbox',
                key: 'is_been_notified',
                value : '1'
            },
            showNotSend : {
                name: 'Is nog niet verstuurd',
                type: 'checkbox',
                key: 'is_been_notified',
                value : '0'
            },

			showDeleted : {
                name: 'Is verwijderd',
                type: 'checkbox',
                key: 'is_deleted',
                value : '1'
            },
            showNotDeleted : {
                name: 'Is niet verwijderd',
                type: 'checkbox',
                key: 'is_deleted',
                value : '0'
            }
        }

        return (

            <div className="animated fadeIn">
                <Card>
                    <CardHeader>
						{this.state.fileData.length ?
							<Search filters={filterValues} data={this.state.fileData} keys_to_filter={['client_string','addresses_string', 'filename', 'product_name', 'upload_date', 'uploaded_by_name', 'file_type_name','metaDataValues']}/>
						: null }
					</CardHeader>
                    <CardBody>
                        <CardTitle><i className="fa fa-file"></i> Berichten overzicht</CardTitle>
                        {this.columns ? <DataTable defaultSorted={[{id: "upload_date",desc: true}]} additionalColumns={this.additionalColumns} data={this.props.searchData.data ? this.props.searchData.data : this.state.fileData} columns={this.columns} /> : <Loader /> }
                    </CardBody>
                </Card>

            </div>
        )
  	}
}


function mapStateToProps(state, ownProps) {

    return {
        fileData: state.FileReducer.files,
        searchData: state.SearchDataReducer,
        clientPath: state.clientPathReducer,
        clientData: state.ClientDataReducer,

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateSearchData: (data) => dispatch(setSearchData(data)),
        getAllFiles: (url) => dispatch(getAllFiles(url)),
        getAllProducts: (url) => dispatch(getAllProducts(url)),
        fileTypeFetchData: (url) =>   dispatch(fileTypeFetchData(url + '/api/files/action/getFileTypes')),
        fileMetaDataValueWithCategoryFetchData: (url) => dispatch(fileMetaDataValueWithCategoryFetchData(url + '/api/files/action/getMetaValuesByCategory')),
        clientFetchData: (url) => dispatch(clientFetchData(url + '/api/clients/action/getclients')),
        deleteFile:(clientPath, fileId, value, addressIndex, fileIndex, addressFileIndex) => dispatch(deleteFile(clientPath, fileId, value, addressIndex, fileIndex, addressFileIndex))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Overview)



// WEBPACK FOOTER //
// ./src/views/Messages/Overview.js